// hooks/useSearchParams.js
import { useHistory, useLocation } from 'react-router-dom';

const useSearchParams = () => {
    const location = useLocation();
    const history = useHistory();
    const searchParams = new URLSearchParams(location.search);

    const getParam = (param) => searchParams.get(param);
    const setParam = (param, value) => {
        searchParams.set(param, value);
        history.push({ search: searchParams.toString() });
    };

    const resetParam = () => history.push(location.pathname);

    return { getParam, setParam, resetParam };
};

export default useSearchParams;
